import { FastField } from "formik"
import { TextField } from "formik-material-ui"
import React from "react"

export const IdNumberField = (props: any) => {
  return (
    <FastField
      style={{
        width: "100%",
      }}
      component={TextField}
      id="info.idNumber"
      name="info.idNumber"
      type="text"
      label="Číslo OP"
    ></FastField>
  )
}
